import menuIconUrl from "../../assets/ccc.png";

const menuIcon = `
    <img 
        src="${menuIconUrl}" 
        alt="" 
        class="menu-icon-image"
    >
`;

export { menuIcon };
